import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
const defaultSerializer = { handler: (node) => node };
const defaultDecorate = () => [];
const defaultElement = {
    match: () => false,
    component: () => _jsx("span", {}),
};
const defaultLeaf = {
    match: () => false,
    style: {},
};
const defaultOverride = (editor) => editor;
function getPluginComponentProps(plugin, children) {
    return React.Children.map(children, (element, index) => {
        var _a, _b;
        if (!React.isValidElement(element))
            return {};
        const displayName = (_a = element.type.displayName) !== null && _a !== void 0 ? _a : index.toString();
        if ((_b = plugin.editorComponents) === null || _b === void 0 ? void 0 : _b.some((type) => type === element.type)) {
            return element.props ? { [displayName]: element.props } : {};
        }
        else {
            return {};
        }
    });
}
function getPluginOptions(plugins, children) {
    return plugins.reduce((prev, curr) => {
        const props = getPluginComponentProps(curr, children);
        prev[curr.name] = Object.assign(Object.assign({}, curr.options), { componentProps: props });
        return prev;
    }, {});
}
function normalizePlugins(plugins = []) {
    return plugins.map((p) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        return ({
            name: p.name,
            leave: (_a = p.leave) !== null && _a !== void 0 ? _a : defaultLeaf,
            element: (_b = p.element) !== null && _b !== void 0 ? _b : defaultElement,
            handlers: (_c = p.handlers) !== null && _c !== void 0 ? _c : {},
            beforeSerialize: (_d = p.beforeSerialize) !== null && _d !== void 0 ? _d : defaultSerializer,
            afterDeserialize: (_e = p.afterDeserialize) !== null && _e !== void 0 ? _e : defaultSerializer,
            override: (_f = p.override) !== null && _f !== void 0 ? _f : defaultOverride,
            decorate: (_g = p.decorate) !== null && _g !== void 0 ? _g : defaultDecorate,
            options: (_h = p.options) !== null && _h !== void 0 ? _h : {},
            editorComponents: (_j = p.editorComponents) !== null && _j !== void 0 ? _j : [],
        });
    });
}
export { getPluginOptions, normalizePlugins, getPluginComponentProps };
